import { Router } from "@reach/router";

import SignUp from "../components/SigninSignup/SignUp.jsx";
import Home from "../components/SigninSignup/Home";
import SignIn from "../components/SigninSignup/SignIn";
import Impressum from "../components/Profile/Impressum";
import Privacy from "../components/Profile/Privacy.jsx";

const PublicRoutes = ({ authenticated }) => (
  <Router>
    <Home path="/" authenticated={authenticated} />
    <SignIn path="sign-in" />
    <SignUp path="create-account" />
    <Privacy path="privacy" />
    <Impressum path="impressum" />
  </Router>
);

export default PublicRoutes;
